/* Kazentek theme 2.0 — vanilla JS, no dependencies. Event delegation + idempotent init (works in the theme editor). */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var isRTL = root.dir === 'rtl';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }
  function sx(el) { return Math.abs(el.scrollLeft); } // RTL-safe horizontal scroll offset
  function dlgClose(d) { if (!d) return; if (d.close) d.close(); else d.removeAttribute('open'); }
  function lockScroll(on) { root.style.overflow = on ? 'hidden' : ''; }

  /* ---------- Header height variable (sticky toolbar / sticky info offsets) ---------- */
  function setHeaderHeight() {
    var h = $('[data-header]');
    if (!h) return;
    var set = function () { root.style.setProperty('--hdr-h', h.offsetHeight + 'px'); };
    set();
    if (window.ResizeObserver) new ResizeObserver(set).observe(h);
  }

  /* ---------- Drawer (mobile menu) ---------- */
  function drawerSet(open) {
    var d = $('[data-drawer]');
    if (!d) return;
    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    $$('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    lockScroll(open);
    if (open) { var f = $('a, button, summary', d.querySelector('.drawer__panel')); if (f) f.focus({ preventScroll: true }); }
  }

  /* ---------- Announcement bar ---------- */
  function initAnnounce(el) {
    if (!once(el, 'kz')) return;
    var items = $$('.announce__item', el);
    if (items.length < 2) return;
    var i = 0, speed = (parseFloat(el.dataset.speed) || 5) * 1000, timer;
    function show(n) {
      i = (n + items.length) % items.length;
      items.forEach(function (it, k) { it.classList.toggle('is-active', k === i); });
    }
    function start() { stop(); if (!reduceMotion) timer = setInterval(function () { show(i + 1); }, speed); }
    function stop() { clearInterval(timer); }
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-announce-prev]')) { show(i - 1); start(); }
      if (e.target.closest('[data-announce-next]')) { show(i + 1); start(); }
    });
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', start);
    start();
  }

  /* ---------- Hero slider ---------- */
  function initHero(el) {
    if (!once(el, 'kz')) return;
    var slides = $$('[data-hero-slide]', el), dots = $$('[data-hero-dot]', el);
    if (slides.length < 2) return;
    var i = 0, timer, paused = false, auto = (parseFloat(el.dataset.autoplay) || 0) * 1000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    }
    function stop() { clearInterval(timer); }
    function start() { stop(); if (auto && !paused && !reduceMotion) timer = setInterval(function () { show(i + 1); }, auto); }
    el.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-hero-prev]')) { show(i - 1); start(); }
      else if (t.closest('[data-hero-next]')) { show(i + 1); start(); }
      else if (t.closest('[data-hero-dot]')) { show(+t.closest('[data-hero-dot]').dataset.heroDot); start(); }
      else if (t.closest('[data-hero-pause]')) {
        paused = !paused; t.closest('[data-hero-pause]').setAttribute('aria-pressed', paused ? 'true' : 'false'); paused ? stop() : start();
      }
    });
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 50) { show(i + ((dx < 0) !== isRTL ? 1 : -1)); start(); }
    }, { passive: true });
    show(0); start();
  }

  /* ---------- Carousels (scroll-snap based) ---------- */
  function initCarousel(el) {
    if (!once(el, 'kz')) return;
    var track = $('[data-carousel-track]', el);
    if (!track) return;
    var prev = $('[data-carousel-prev]', el), next = $('[data-carousel-next]', el), bar = $('[data-carousel-bar]', el);
    function update() {
      var max = track.scrollWidth - track.clientWidth, pos = sx(track);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
      if (prev && next) { var hide = max <= 2; prev.hidden = hide; next.hidden = hide; }
      if (bar) {
        var w = max <= 2 ? 100 : Math.max(12, track.clientWidth / track.scrollWidth * 100);
        bar.style.width = w + '%';
        bar.style.insetInlineStart = (max <= 2 ? 0 : pos / max * (100 - w)) + '%';
      }
    }
    function go(dir) {
      track.scrollBy({ left: dir * (isRTL ? -1 : 1) * track.clientWidth * 0.85, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', debounce(update, 40), { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(track);
    window.addEventListener('load', update);
    update();
  }

  /* ---------- Tabs ---------- */
  function initTabs(el) {
    if (!once(el, 'kz')) return;
    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-tab]');
      if (!b || !el.contains(b)) return;
      var n = b.dataset.tab;
      $$('[data-tab]', el).forEach(function (t) { var on = t === b; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
      $$('[data-tab-panel]', el).forEach(function (p) { p.hidden = p.dataset.tabPanel !== n; });
      var sec = el.closest('section') || el.parentNode;
      $$('[data-tab-link]', sec).forEach(function (a) { a.hidden = a.dataset.tabLink !== n; });
      $$('[data-carousel]', el).forEach(function (c) { var tr = $('[data-carousel-track]', c); if (tr) tr.dispatchEvent(new Event('scroll')); });
    });
  }

  /* ---------- Card quick-add ---------- */
  function closeQuick(except) {
    $$('[data-quick-toggle][aria-expanded="true"]').forEach(function (b) {
      if (b === except) return;
      b.setAttribute('aria-expanded', 'false');
      var p = $('[data-quick-panel]', b.closest('[data-card]')); if (p) p.hidden = true;
    });
  }

  /* ---------- Predictive search ---------- */
  function money(v, cur) {
    var n = parseFloat(v); if (isNaN(n)) return '';
    var c = cur || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
    var s = new Intl.NumberFormat(root.lang || undefined, { maximumFractionDigits: 0 }).format(n);
    return c === 'DZD' ? s + ' DA' : s + (c ? ' ' + c : '');
  }
  function esc(s) { var d = doc.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML.replace(/"/g, '&quot;').replace(/'/g, '&#39;'); }
  function initSearch(el) {
    if (!once(el, 'kz')) return;
    var input = $('[data-search-input]', el), box = $('[data-search-results]', el);
    if (!input || !box) return;
    var form = input.form, ctrl, last = '';
    function close() { box.hidden = true; box.innerHTML = ''; }
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { close(); last = ''; return; }
      if (q === last) return;
      last = q;
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = shopRoot + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      fetch(url, ctrl ? { signal: ctrl.signal } : undefined).then(function (r) { return r.json(); }).then(function (j) {
        var res = (j.resources && j.resources.results) || {}, h = '';
        var cols = res.collections || [], prods = res.products || [];
        if (cols.length) {
          h += '<p class="psearch__group">' + esc(box.dataset.lCollections) + '</p>';
          cols.slice(0, 3).forEach(function (c) { h += '<a class="psearch__text" href="' + esc(c.url) + '">' + esc(c.title) + '</a>'; });
        }
        prods.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          h += '<a class="psearch__item" href="' + esc(p.url) + '">' +
            (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '<span></span>') +
            '<span><span class="psearch__t">' + esc(p.title) + '</span><span class="psearch__p">' + esc(money(p.price)) + '</span></span></a>';
        });
        if (!h) { close(); return; }
        h += '<a class="psearch__all" href="' + esc(form.action) + '?q=' + encodeURIComponent(q) + '">' + esc(box.dataset.lAll) + '</a>';
        box.innerHTML = h; box.hidden = false;
      }).catch(function () { });
    }, 220);
    input.addEventListener('input', run);
    input.addEventListener('focus', function () { if (box.innerHTML) box.hidden = false; });
    doc.addEventListener('click', function (e) { if (!el.contains(e.target)) box.hidden = true; });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); input.blur(); } });
  }

  /* ---------- Collection page: AJAX filtering ---------- */
  var shopCtrl;
  function initShop(shop) {
    if (!once(shop, 'kz')) return;
    var panel = $('[data-filters]', shop), form = $('[data-filters-form]', shop), sortForm = $('[data-sort-form]', shop);
    var layout = shop.dataset.layout;

    // Safety net for older WebViews without overflow:clip: if focus scrolls the sheet itself, snap it back.
    var sheetPanel = panel ? $('.filters__panel', panel) : null;
    if (sheetPanel) sheetPanel.addEventListener('scroll', function () { if (sheetPanel.scrollTop || sheetPanel.scrollLeft) { sheetPanel.scrollTop = 0; sheetPanel.scrollLeft = 0; } });
    var pendingResults = null, loading = null, loadingUrl = null, loadedUrl = null;
    function sheetModal() { return !!panel && panel.classList.contains('is-open') && !(layout === 'sidebar' && window.innerWidth >= 990); }
    function flushResults() {
      if (!pendingResults) return;
      var el = $('[data-swap="results"]', shop), n = $('[data-swap="results"]', pendingResults);
      pendingResults = null;
      if (el && n) el.innerHTML = n.innerHTML;
      autoCount = 0; watchAuto();
      var top = shop.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(root).getPropertyValue('--hdr-h'), 10) || 0) - 8;
      if (window.pageYOffset > top) window.scrollTo(0, Math.max(0, top));
    }
    function sheet(open) {
      if (!panel) return;
      panel.classList.toggle('is-open', open);
      lockScroll(open && !(layout === 'sidebar' && window.innerWidth >= 990));
      if (open) { var c = $('.filters__close', panel); if (c) c.focus({ preventScroll: true }); }
      else { flushResults(); watchAuto(); }
    }
    function stockPref(url) {
      try {
        var re = /[?&]filter\.v\.availability=1/, had = re.test(location.search), has = re.test(url);
        if (had && !has) sessionStorage.setItem('kzAllStock', '1'); else if (has) sessionStorage.removeItem('kzAllStock');
      } catch (e) { }
    }

    function buildUrl() {
      var p = new URLSearchParams();
      if (form) new FormData(form).forEach(function (v, k) { if (v !== '' && v != null) p.append(k, v); });
      if (sortForm) { var s = $('[name="sort_by"]', sortForm); if (s && s.value) p.set('sort_by', s.value); }
      var qs = p.toString();
      return (form ? form.action : location.pathname) + (qs ? '?' + qs : '');
    }

    // Shopify drops values with 0 results from the response (and adds them back later), so each filter
    // group is rebuilt from the fresh page instead of patched. UI state is kept per group.
    function rebuildFacets(nshop) {
      var nform = $('[data-filters-form]', nshop);
      if (!form || !nform) return;
      var state = {}, act = doc.activeElement, actName = '', actVal = '';
      if (act && form.contains(act) && act.name) { actName = act.name; actVal = act.value; }
      $$('[data-fgroup]', form).forEach(function (g) {
        var list = $('[data-flist]', g), q = $('[data-fsearch]', g);
        state[g.dataset.fgroup] = { open: g.open, exp: list ? list.dataset.userExpanded === '1' : false, st: list ? list.scrollTop : 0, q: q ? q.value : '' };
      });
      var price = $('[data-fgroup][data-kind="price"]', form), top = form.scrollTop;
      form.innerHTML = nform.innerHTML;
      if (price) {
        var np = $('[data-fgroup][data-kind="price"]', form);
        if (np) {
          var os = $('summary', price), ns = $('summary', np);
          if (os && ns) os.innerHTML = ns.innerHTML;
          np.parentNode.replaceChild(price, np);
        }
      }
      $$('[data-fgroup]', form).forEach(function (g) {
        var st = state[g.dataset.fgroup];
        if (!st || g === price) return;
        g.open = st.open;
        var list = $('[data-flist]', g), q = $('[data-fsearch]', g), more = $('[data-fmore]', g);
        if (list && st.exp) { list.dataset.userExpanded = '1'; list.classList.add('is-expanded'); }
        if (q && st.q) {
          q.value = st.q;
          $$('.frow', list).forEach(function (r) { r.classList.toggle('is-hidden', (r.dataset.label || '').indexOf(st.q.trim().toLowerCase()) < 0); });
          if (list) list.classList.add('is-expanded');
        }
        if (list) list.scrollTop = st.st;
      });
      form.scrollTop = top;
      if (actName) {
        $$('input', form).some(function (x) {
          if (x.name === actName && x.value === actVal && x.type !== 'number') { try { x.focus({ preventScroll: true }); } catch (e) { } return true; }
          return false;
        });
        form.scrollTop = top;
      }
    }

    function syncFacets(nshop, rebuild) {
      if (rebuild) rebuildFacets(nshop);
      ['data-price-min', 'data-price-max'].forEach(function (a) {
        var cur = $('[' + a + ']', shop), nx = $('[' + a + ']', nshop);
        if (cur && nx && doc.activeElement !== cur) cur.value = nx.value;
      });
      markPresets(); rangeFromNumbers(); tidyFacets();
      var clr = $('[data-filters-clear]', shop), nclr = $('[data-filters-clear]', nshop);
      if (clr && nclr) clr.href = nclr.href;
    }

    // "Voir plus (+12)" / "Voir moins": the count tells shoppers how many values are behind the button.
    function moreLabel(btn, list) {
      var n = $$('.frow.is-extra', list).length; // tidyFacets only marks visible (non-empty) values as extra
      var open = list.classList.contains('is-expanded');
      btn.textContent = open ? btn.dataset.less : btn.dataset.more + (n ? ' (+' + n + ')' : '');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    // Scroll the panel (or the list's own scroll box) just enough to show el.
    function bringIntoView(el, list) {
      var sc = list && list.classList.contains('is-long') && list.scrollHeight > list.clientHeight ? list : el.closest('.filters__body');
      if (!sc || sc.scrollHeight <= sc.clientHeight) return;
      var sr = sc.getBoundingClientRect(), er = el.getBoundingClientRect();
      if (er.top >= sr.top && er.bottom <= sr.bottom - 24) return;
      var top = sc.scrollTop + (er.top - sr.top) - 48;
      try { sc.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' }); } catch (e) { sc.scrollTop = top; }
    }

    // Hide values with no products (and groups left empty); keep "show more" counting only visible values.
    function tidyFacets() {
      var hide = shop.hasAttribute('data-hide-empty');
      $$('[data-flist]', shop).forEach(function (list) {
        var limit = parseInt(list.dataset.limit, 10) || 8, i = 0;
        $$('.frow', list).forEach(function (r) {
          var inp = $('input', r), on = !!(inp && inp.checked), live = on || !(hide && r.classList.contains('is-dead'));
          if (live) i++;
          r.classList.toggle('is-extra', live && i > limit && !on);
        });
        var more = $('[data-fmore]', list.parentNode);
        if (more) { more.hidden = i <= limit; moreLabel(more, list); }
      });
      if (!hide) return;
      $$('.fgroup', shop).forEach(function (g) {
        var f = $$('[data-facet]', g);
        if (!f.length) return;
        g.classList.toggle('is-empty', !f.some(function (el) { var inp = $('input', el); return (inp && inp.checked) || !el.classList.contains('is-dead'); }));
      });
    }

    function markPresets() {
      var mn = $('[data-price-min]', shop), mx = $('[data-price-max]', shop);
      if (!mn || !mx) return;
      $$('[data-price-preset]', shop).forEach(function (b) {
        b.classList.toggle('is-on', (b.dataset.min || '') === (mn.value || '') && (b.dataset.max || '') === (mx.value || ''));
      });
    }

    function paintRange() {
      var r = $('[data-range]', shop); if (!r) return;
      var lo = $('[data-range-lo]', r), hi = $('[data-range-hi]', r), max = +r.dataset.max || 1;
      r.style.setProperty('--lo', (+lo.value / max * 100) + '%');
      r.style.setProperty('--hi', (+hi.value / max * 100) + '%');
    }
    function rangeFromNumbers() {
      var r = $('[data-range]', shop); if (!r) return;
      var mn = $('[data-price-min]', shop), mx = $('[data-price-max]', shop), max = +r.dataset.max || 0;
      $('[data-range-lo]', r).value = mn && mn.value !== '' ? mn.value : 0;
      $('[data-range-hi]', r).value = mx && mx.value !== '' ? mx.value : max;
      paintRange();
    }
    function numbersFromRange(src) {
      var r = $('[data-range]', shop); if (!r) return;
      var lo = $('[data-range-lo]', r), hi = $('[data-range-hi]', r), max = +r.dataset.max || 0;
      if (+lo.value > +hi.value) { if (src === lo) lo.value = hi.value; else hi.value = lo.value; }
      var mn = $('[data-price-min]', shop), mx = $('[data-price-max]', shop);
      if (mn) mn.value = +lo.value > 0 ? lo.value : '';
      if (mx) mx.value = +hi.value < max ? hi.value : '';
      paintRange(); markPresets();
    }

    function load(url, opts) {
      opts = opts || {};
      if (shopCtrl) shopCtrl.abort();
      var ctrl = shopCtrl = window.AbortController ? new AbortController() : null;
      if (opts.push !== false) stockPref(url);
      shop.classList.add('is-loading');
      var slow = setTimeout(function () { location.href = url; }, 12000); // stalled request (weak network / WebView): do a normal page load
      loadingUrl = url;
      var p = loading = fetch(url, ctrl ? { signal: ctrl.signal } : undefined).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var nshop = $('[data-collection]', d);
        if (!nshop) { location.href = url; return; }
        // While the mobile sheet covers the page, only update the sheet + counts; the product grid is swapped once on close.
        var defer = sheetModal();
        pendingResults = null;
        $$('[data-swap]', shop).forEach(function (el) {
          if (defer && el.dataset.swap === 'results') { pendingResults = nshop; return; }
          var n = $('[data-swap="' + el.dataset.swap + '"]', nshop);
          if (n) el.innerHTML = n.innerHTML;
        });
        $$('[data-qf]').forEach(function (el) {
          var n = d.querySelector('[data-qf="' + el.dataset.qf + '"]');
          if (n) el.innerHTML = n.innerHTML;
        });
        if (!defer) { autoCount = 0; watchAuto(); }
        loadedUrl = url;
        syncFacets(nshop, !(opts.fromForm && buildUrl() !== url));
        if (opts.push !== false) history.pushState({ kz: 1 }, '', url);
        if (opts.scroll) {
          var top = shop.getBoundingClientRect().top + window.pageYOffset - (parseInt(getComputedStyle(root).getPropertyValue('--hdr-h'), 10) || 0) - 8;
          window.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        location.href = url;
      }).then(function () {
        clearTimeout(slow);
        if (loading === p) { loading = null; loadingUrl = null; shop.classList.remove('is-loading'); }
      });
      return p;
    }

    var apply = debounce(function () {
      var u = buildUrl();
      if (u === (loading ? loadingUrl : loadedUrl)) return;
      load(u, { fromForm: true });
    }, 260);

    shop.addEventListener('change', function (e) {
      var t = e.target;
      if (form && form.contains(t)) apply();
      else if (sortForm && sortForm.contains(t)) load(buildUrl());
    });
    shop.addEventListener('submit', function (e) {
      if (form && (e.target === form)) {
        e.preventDefault();
        var u = buildUrl();
        if (loading && u === loadingUrl) loading.then(function () { sheet(false); });
        else if (!loading && u === loadedUrl) sheet(false);
        else load(u, { fromForm: true }).then(function () { sheet(false); });
      }
      else if (sortForm && e.target === sortForm) { e.preventDefault(); load(buildUrl()); }
    });
    shop.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-fsearch]')) {
        var q = t.value.trim().toLowerCase(), list = $('[data-flist]', t.closest('.fgroup__body'));
        if (!list) return;
        $$('.frow', list).forEach(function (r) { r.classList.toggle('is-hidden', !!q && (r.dataset.label || '').indexOf(q) < 0); });
        list.classList.toggle('is-expanded', !!q || list.dataset.userExpanded === '1');
      } else if (t.matches('[data-range-lo],[data-range-hi]')) {
        numbersFromRange(t);
      } else if (t.matches('[data-price-min],[data-price-max]')) {
        markPresets(); rangeFromNumbers();
      }
    });
    shop.addEventListener('click', function (e) {
      var t = e.target;
      var a;
      if ((a = t.closest('[data-filters-open]'))) { sheet(true); return; }
      if (t.closest('[data-filters-close]')) { sheet(false); return; }
      if ((a = t.closest('[data-filter-jump]'))) {
        var target = doc.getElementById(a.dataset.filterJump);
        if (!target) return;
        sheet(true);
        if (target.tagName === 'DETAILS') target.open = true;
        setTimeout(function () { target.scrollIntoView({ block: 'nearest', behavior: reduceMotion ? 'auto' : 'smooth' }); }, 60);
        return;
      }
      if ((a = t.closest('[data-price-preset]'))) {
        var mn = $('[data-price-min]', shop), mx = $('[data-price-max]', shop);
        if (mn && mx) { mn.value = a.dataset.min || ''; mx.value = a.dataset.max || ''; markPresets(); rangeFromNumbers(); apply(); }
        return;
      }
      if ((a = t.closest('[data-fmore]'))) {
        var list = $('[data-flist]', a.closest('.fgroup__body'));
        if (!list) return;
        var open = !list.classList.contains('is-expanded');
        list.classList.toggle('is-expanded', open);
        list.dataset.userExpanded = open ? '1' : '';
        moreLabel(a, list);
        if (open) {
          // Feedback: the new values slide in with a short highlight, and the first one is scrolled into view.
          var added = $$('.frow.is-extra', list).filter(function (r) { return getComputedStyle(r).display !== 'none'; });
          added.forEach(function (r, i) { r.classList.remove('is-reveal'); void r.offsetWidth; r.style.animationDelay = Math.min(i * 35, 350) + 'ms'; r.classList.add('is-reveal'); });
          setTimeout(function () { added.forEach(function (r) { r.classList.remove('is-reveal'); r.style.animationDelay = ''; }); }, 1600);
          if (added[0]) bringIntoView(added[0], list);
        } else {
          list.scrollTop = 0;
          bringIntoView(a, null);
        }
        return;
      }
      if ((a = t.closest('[data-load-more]'))) {
        e.preventDefault();
        loadMore(a);
        return;
      }
      if ((a = t.closest('.achip, [data-filters-clear], .pagination a'))) {
        if (a.tagName !== 'A' || !a.href || e.metaKey || e.ctrlKey) return;
        e.preventDefault();
        load(a.href, { scroll: !!a.closest('.pagination') });
      }
    });
    function loadMore(a) {
      var holder = a.closest('[data-loadmore]');
      if (!holder || holder.classList.contains('is-loading')) return;
      holder.classList.add('is-loading');
      fetch(a.href).then(function (r) { return r.text(); }).then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var ngrid = $('[data-grid]', d), grid = $('[data-grid]', shop);
        if (ngrid && grid) {
          $$(':scope > li', ngrid).forEach(function (li) { grid.appendChild(doc.importNode(li, true)); });
          var nlm = $('[data-loadmore]', d);
          if (nlm) holder.replaceWith(doc.importNode(nlm, true)); else holder.remove();
          var pg = $('.pagination', shop), npg = $('.pagination', d);
          if (pg) { if (npg) pg.replaceWith(doc.importNode(npg, true)); else pg.remove(); }
          watchAuto();
        } else { location.href = a.href; }
      }).catch(function () { location.href = a.href; });
    }

    // Auto-load: the next page loads as the "see more" block nears the screen, up to data-auto pages, then the button stays.
    var autoIo = null, autoCount = 0;
    function watchAuto() {
      if (autoIo) { autoIo.disconnect(); autoIo = null; }
      var lm = $('[data-loadmore][data-auto]', shop);
      if (!lm || !('IntersectionObserver' in window)) return;
      var max = parseInt(lm.dataset.auto, 10) || 3;
      if (autoCount >= max) return;
      autoIo = new IntersectionObserver(function (en) {
        if (!en.some(function (x) { return x.isIntersecting; }) || sheetModal() || shop.classList.contains('is-loading')) return;
        var a = $('[data-load-more]', lm);
        if (!a) return;
        autoIo.disconnect(); autoIo = null; autoCount++;
        loadMore(a);
      }, { rootMargin: '0px 0px 700px 0px' });
      autoIo.observe(lm);
    }
    shop.kzLoad = function (url) { return load(url, {}); };

    window.addEventListener('popstate', function () { if (shop.isConnected) load(location.href, { push: false }); });
    watchAuto();
    tidyFacets();
    markPresets(); paintRange();
  }

  /* ---------- Product page ---------- */
  function initPdp(pdp) {
    if (!once(pdp, 'kz')) return;
    var gallery = $('[data-gallery]', pdp), items = gallery ? $$('.gallery__item', gallery) : [];
    var thumbs = $$('[data-thumb]', pdp), dots = $$('[data-gallery-dots] span', pdp), bar = $('[data-gallery-bar]', pdp);
    var counts = $$('[data-gallery-count]', pdp);

    function scrollable() { return gallery && gallery.scrollWidth > gallery.clientWidth + 4; }
    function current() { return gallery && gallery.clientWidth ? Math.round(sx(gallery) / gallery.clientWidth) : 0; }
    function mark(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      counts.forEach(function (c) { c.textContent = (i + 1) + ' / ' + items.length; });
      if (bar && items.length) bar.style.width = ((i + 1) / items.length * 100) + '%';
    }
    if (gallery) {
      gallery.addEventListener('scroll', debounce(function () { if (scrollable()) mark(current()); }, 30), { passive: true });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var i = +t.dataset.thumb;
          if (scrollable() && items[i]) gallery.scrollTo({ left: (isRTL ? -1 : 1) * i * gallery.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
          else if (items[i]) items[i].scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
          mark(i);
        });
      });
    }

    /* Lightbox */
    var lb = $('[data-lightbox]', pdp), lbImg = lb && $('[data-lightbox-img]', lb), zooms = $$('[data-lightbox-open]', pdp), li = 0;
    function lbShow(i) {
      li = (i + zooms.length) % zooms.length;
      lbImg.src = zooms[li].dataset.src;
    }
    if (lb && lbImg && zooms.length) {
      zooms.forEach(function (z) { z.addEventListener('click', function () { lbShow(+z.dataset.lightboxOpen); if (lb.showModal) lb.showModal(); else lb.setAttribute('open', ''); }); });
      lb.addEventListener('click', function (e) {
        if (e.target === lb || e.target.closest('[data-lightbox-close]')) dlgClose(lb);
        else if (e.target.closest('[data-lightbox-prev]')) lbShow(li + (isRTL ? 1 : -1));
        else if (e.target.closest('[data-lightbox-next]')) lbShow(li + (isRTL ? -1 : 1));
      });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') lbShow(li + (isRTL ? 1 : -1));
        if (e.key === 'ArrowRight') lbShow(li + (isRTL ? -1 : 1));
      });
      lb.addEventListener('close', function () { lbImg.removeAttribute('src'); if (gallery && items[li] && scrollable()) gallery.scrollTo({ left: (isRTL ? -1 : 1) * li * gallery.clientWidth }); });
    }

    /* Sizes */
    var radios = $$('input[name="id"]', pdp), err = $('[data-size-error]', pdp), form = $('[data-product-form]', pdp);
    radios.forEach(function (r) {
      r.addEventListener('change', function () {
        if (err) err.textContent = '';
        try { var u = new URL(location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u); } catch (e) { }
      });
    });
    if (form) {
      var hasSizes = radios.length > 0;
      var addBtns = $$('[data-add-btn]', pdp);
      addBtns.forEach(function (b) {
        b.addEventListener('click', function (e) {
          if (hasSizes && !radios.some(function (x) { return x.checked; })) {
            e.preventDefault();
            if (err) { err.textContent = err.dataset.message || ''; var box = err.closest('[data-buy-box]'); if (box) box.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' }); }
          }
        });
      });
    }

    /* Quantity */
    pdp.addEventListener('click', function (e) {
      var q = e.target.closest('[data-qty]');
      if (q) {
        var inp = $('input', q.closest('[data-qty-wrap]')), v = (parseInt(inp.value, 10) || 1) + parseInt(q.dataset.qty, 10);
        inp.value = Math.max(parseInt(inp.min, 10) || 1, v);
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var sh = e.target.closest('[data-share]');
      if (sh) {
        var data = { title: sh.dataset.title, url: sh.dataset.url };
        if (navigator.share) { navigator.share(data).catch(function () { }); }
        else if (navigator.clipboard) {
          navigator.clipboard.writeText(sh.dataset.url).then(function () {
            var s = $('span', sh), old = s.textContent; s.textContent = sh.dataset.copied; setTimeout(function () { s.textContent = old; }, 2000);
          });
        }
      }
    });

    /* Size guide modal */
    pdp.addEventListener('click', function (e) {
      var o = e.target.closest('[data-modal-open]');
      if (o) { var m = doc.getElementById(o.dataset.modalOpen); if (m) { if (m.showModal) m.showModal(); else m.setAttribute('open', ''); } return; }
      var c = e.target.closest('[data-modal-close]');
      if (c) { dlgClose(c.closest('dialog')); return; }
      if (e.target.matches && e.target.matches('dialog.modal')) dlgClose(e.target);
    });

    /* COD leadform (embed.js): it already follows the product form's hidden id, ?variant= and the variant:changed event */
    var cod = $('[data-cod]', pdp), codVars = [];
    function variantById(id) { for (var i = 0; i < codVars.length; i++) if (String(codVars[i].id) === String(id)) return codVars[i]; return null; }
    function selectedId() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      return r ? r.value : null;
    }
    function announceVariant(id) {
      var hid = $('form[action="/cart/add"] input[name="id"]', doc);
      if (hid) hid.value = id;
      doc.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant: { id: parseInt(id, 10) } } }));
    }
    var stockEl = $('[data-stock]', pdp);
    function updateStock(v) {
      if (!stockEl) return;
      stockEl.hidden = !(v && v.low);
    }
    function syncVariant() {
      var id = selectedId();
      updateStock(variantById(id));
      if (id) announceVariant(id);
    }
    try { codVars = JSON.parse($('[data-variants]', pdp).textContent); } catch (e) { }
    radios.forEach(function (r) { r.addEventListener('change', syncVariant); });
    syncVariant();

    /* Sticky buy bar: shows when the order form is out of view */
    var sbar = $('[data-sticky-buy]', pdp) || $('[data-sticky-buy]');
    var anchor = cod || $$('[data-buy-box]', pdp).pop() || $('[data-add-btn]', pdp);
    var anchorSeen = false;
    function sbarUpdate() {
      if (!sbar) return;
      var show = !anchorSeen && window.pageYOffset > 240;
      sbar.classList.toggle('is-visible', show);
      sbar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if (sbar && anchor && window.IntersectionObserver) {
      new IntersectionObserver(function (en) { anchorSeen = en[0].isIntersecting; sbarUpdate(); }).observe(anchor);
      window.addEventListener('scroll', debounce(sbarUpdate, 30), { passive: true });
    }
    $$('[data-scroll-buy]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var sr = $$('input[type="radio"][name="id"]', pdp), needSize = sr.length && !sr.some(function (x) { return x.checked; });
        var tgt = needSize ? ($('[data-sizes]', pdp) || cod) : (cod || anchor);
        if (tgt) tgt.scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });
        if (needSize && err) err.textContent = err.dataset.message || '';
      });
    });

    /* Recently viewed: remember this product */
    try {
      var h = pdp.dataset.productHandle, list = JSON.parse(localStorage.getItem('kz_rv') || '[]');
      list = list.filter(function (x) { return x !== h; }); list.unshift(h);
      localStorage.setItem('kz_rv', JSON.stringify(list.slice(0, 20)));
    } catch (e) { }
  }

  /* ---------- Recently viewed ---------- */
  function initRecentlyViewed(el) {
    if (!once(el, 'kz')) return;
    var list = [], cur = ($('[data-pdp]') || {}).dataset;
    try { list = JSON.parse(localStorage.getItem('kz_rv') || '[]'); } catch (e) { }
    var skip = cur && cur.productHandle;
    list = list.filter(function (h) { return h !== skip; }).slice(0, parseInt(el.dataset.limit, 10) || 8);
    if (!list.length) return;
    var ul = $('[data-recently-viewed-list]', el);
    Promise.all(list.map(function (h) {
      return fetch(shopRoot + 'products/' + encodeURIComponent(h) + '?view=card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (parts) {
      var any = false;
      parts.forEach(function (html) {
        if (!html || html.indexOf('data-card') < 0) return;
        var li = doc.createElement('li'); li.className = 'car__item'; li.innerHTML = html.trim(); ul.appendChild(li); any = true;
      });
      if (any) { el.hidden = false; var c = el.closest('.s') || el; $$('[data-carousel]', c).forEach(initCarousel); var tr = $('[data-carousel-track]', el); if (tr) tr.dispatchEvent(new Event('scroll')); }
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecs(el) {
    if (!once(el, 'kz')) return;
    if ($('.car', el)) return;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html'), n = $('[data-recs]', d);
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; $$('[data-carousel]', el).forEach(initCarousel); }
      else { var s = el.closest('.s'); if (s) s.hidden = true; }
    }).catch(function () { });
  }

  /* ---------- WhatsApp links: always carry the page link (and product / size when relevant) ---------- */
  function cleanUrl() {
    try {
      var u = new URL(location.href);
      Array.from(u.searchParams.keys()).forEach(function (k) {
        if (/^(utm_|fbclid|igshid|gclid|ttclid|msclkid|_ga|mc_)/i.test(k)) u.searchParams.delete(k);
      });
      u.hash = '';
      return u.toString();
    } catch (e) { return location.href; }
  }
  function waHref(a) {
    var href = a.getAttribute('href') || '';
    var base = href.split('?')[0];
    var size = '', r = $('input[type="radio"][name="id"]:checked');
    if (r && r.dataset.variantTitle && r.dataset.variantTitle !== 'Default Title') size = r.dataset.variantTitle;
    var parts = [a.dataset.waText || ''];
    if (a.dataset.waTitle) parts.push(a.dataset.waTitle);
    if (size) parts.push((a.dataset.waSizeLabel || 'Pointure') + ' : ' + size);
    parts.push(a.dataset.waUrl || cleanUrl());
    a.setAttribute('href', base + '?text=' + encodeURIComponent(parts.filter(Boolean).join('\n')));
  }
  function initWa(ctx) { $$('a[data-wa]', ctx || doc).forEach(waHref); }
  doc.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('a[data-wa]');
    if (w) waHref(w);
  }, true);
  doc.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('input[name="id"]')) initWa();
  });

  /* ---------- Media: background video plays only when visible; YouTube/Vimeo load on tap ---------- */
  function initMediaVideo(v) {
    if (!once(v, 'kz')) return;
    if (!v.hasAttribute('data-autoplay')) return; // tap-to-play videos use native controls
    v.muted = true; // some WebViews ignore the attribute
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // keep the thumbnail still
    var slide = v.closest('[data-hero-slide]'), inView = true;
    function shown() { return v.getClientRects().length > 0 && (!slide || slide.classList.contains('is-active')); }
    function sync() {
      if (inView && shown() && !doc.hidden) {
        v.preload = 'auto';
        var p = v.play(); if (p && p.catch) p.catch(function () { });
      } else if (!v.paused) v.pause();
    }
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; sync(); }).observe(v);
    else sync();
    window.addEventListener('resize', debounce(sync, 150));
    doc.addEventListener('visibilitychange', sync);
    if (slide && window.MutationObserver) new MutationObserver(sync).observe(slide, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Countdown (sections and product block) ---------- */
  function parseEnd(v) {
    if (!v) return NaN;
    v = String(v).trim().replace(' ', 'T');
    if (/^\d{4}-\d{2}-\d{2}$/.test(v)) v += 'T23:59:59';
    if (!/(Z|[+-]\d{2}:?\d{2})$/.test(v)) v += '+01:00'; // Algeria time
    var t = Date.parse(v);
    if (isNaN(t)) { // strict parsers (old iOS WebViews): build the date by hand, Algeria = UTC+1
      var m = v.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/);
      if (m) t = Date.UTC(+m[1], m[2] - 1, +m[3], +m[4] - 1, +m[5], +(m[6] || 0));
    }
    return t;
  }
  function initCountdown(el) {
    if (!once(el, 'kz')) return;
    var end = parseEnd(el.dataset.end), tick;
    var c = { d: $('[data-cd="d"]', el), h: $('[data-cd="h"]', el), m: $('[data-cd="m"]', el), s: $('[data-cd="s"]', el) };
    function pad(n) { return n < 10 ? '0' + n : '' + n; }
    function finish() {
      if (tick) clearInterval(tick);
      if (window.Shopify && window.Shopify.designMode) return;
      if (el.dataset.expired === 'hide') { el.classList.add('is-done'); var sec = el.closest('.s'); if (sec && el.classList.contains('cdbanner')) sec.hidden = true; }
    }
    function paint() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (isNaN(left) || left <= 0) { Object.keys(c).forEach(function (k) { if (c[k]) c[k].textContent = '00'; }); finish(); return false; }
      if (c.d) c.d.textContent = pad(Math.floor(left / 86400));
      if (c.h) c.h.textContent = pad(Math.floor(left % 86400 / 3600));
      if (c.m) c.m.textContent = pad(Math.floor(left % 3600 / 60));
      if (c.s) c.s.textContent = pad(left % 60);
      return true;
    }
    if (paint()) tick = setInterval(paint, 1000);
  }

  /* ---------- Global init ---------- */
  function run(sel, fn, ctx) {
    $$(sel, ctx).forEach(function (el) { try { fn(el); } catch (err) { if (window.console) console.error('[kazentek]', sel, err); } });
  }
  function init(ctx) {
    ctx = ctx || doc;
    run('[data-announce]', initAnnounce, ctx);
    run('[data-hero]', initHero, ctx);
    run('[data-carousel]', initCarousel, ctx);
    run('[data-tabs]', initTabs, ctx);
    run('[data-search]', initSearch, ctx);
    run('[data-collection]', initShop, ctx);
    run('[data-pdp]', initPdp, ctx);
    run('[data-recently-viewed]', initRecentlyViewed, ctx);
    run('[data-recs]', initRecs, ctx);
    run('[data-media-video]', initMediaVideo, ctx);
    run('[data-countdown]', initCountdown, ctx);
    try { initWa(ctx); } catch (err) { }
  }

  doc.addEventListener('click', function (e) {
    var t = e.target;
    var ext = t.closest && t.closest('[data-media-ext]');
    if (ext && t.closest('.media__play')) {
      e.preventDefault();
      var fr = doc.createElement('iframe');
      fr.src = ext.dataset.embed; fr.title = ext.dataset.title || 'Video';
      fr.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen'); fr.setAttribute('allowfullscreen', '');
      ext.innerHTML = ''; ext.appendChild(fr);
      return;
    }
    if (t.closest('[data-drawer-open]')) { drawerSet(true); return; }
    if (t.closest('[data-drawer-close]')) { drawerSet(false); return; }
    var qt = t.closest('[data-quick-toggle]');
    if (qt) {
      var open = qt.getAttribute('aria-expanded') !== 'true';
      closeQuick(open ? qt : null);
      qt.setAttribute('aria-expanded', open ? 'true' : 'false');
      var p = $('[data-quick-panel]', qt.closest('[data-card]')); if (p) p.hidden = !open;
      return;
    }
    if (!t.closest('[data-card]')) closeQuick();
    var cl = t.closest('[data-clamp]');
    if (cl) cl.classList.toggle('is-clamped');
  });

  doc.addEventListener('change', function (e) {
    var s = e.target.closest && e.target.closest('select[data-autosubmit]');
    if (s && s.form && !s.form.hasAttribute('data-sort-form')) s.form.submit();
  });

  doc.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    drawerSet(false);
    closeQuick();
    var p = $('[data-filters].is-open');
    if (p) { var pc = $('.filters__close', p); if (pc) pc.click(); else { p.classList.remove('is-open'); lockScroll(false); } }
  });

  setHeaderHeight();
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Shopify theme editor: re-init sections when edited */
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); setHeaderHeight(); });
  /* Editor helper: tap a filter name/value to copy it */
  doc.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-qf-copy]') : null;
    if (!b) return;
    var txt = b.getAttribute('data-qf-copy');
    var done = function () { b.classList.add('is-copied'); setTimeout(function () { b.classList.remove('is-copied'); }, 900); };
    var fallback = function () { var ta = doc.createElement('textarea'); ta.value = txt; ta.style.position = 'fixed'; ta.style.opacity = '0'; doc.body.appendChild(ta); ta.select(); try { doc.execCommand('copy'); done(); } catch (er) { } ta.remove(); };
    try { if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(txt).then(done, fallback); else fallback(); } catch (er) { fallback(); }
  });

  /* Quick filter chips: toggle one Shopify filter value on the current collection (AJAX when the grid is on the page) */
  doc.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-qf-chip]') : null;
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var wrap = a.closest('[data-qf]');
    try {
      var u = new URL(location.href), p = u.searchParams;
      var drop = function (name, val) { var keep = p.getAll(name).filter(function (v) { return v !== val; }); p.delete(name); keep.forEach(function (v) { p.append(name, v); }); };
      var chips = wrap ? $$('[data-qf-chip][data-param]', wrap) : [];
      if (a.hasAttribute('data-all')) {
        chips.forEach(function (c) { drop(c.dataset.param, c.dataset.value); });
      } else {
        var on = a.classList.contains('is-on');
        if (wrap && wrap.dataset.single === '1') chips.forEach(function (c) { if (c !== a) drop(c.dataset.param, c.dataset.value); });
        drop(a.dataset.param, a.dataset.value);
        if (!on) p.append(a.dataset.param, a.dataset.value);
      }
      p.delete('page');
      var url = u.pathname + (p.toString() ? '?' + p.toString() : '') + u.hash;
      var shop = $('[data-collection]');
      e.preventDefault();
      if (shop && shop.kzLoad) {
        if (wrap) {
          var isAll = a.hasAttribute('data-all'), single = wrap.dataset.single === '1', turnOn = !a.classList.contains('is-on');
          chips.forEach(function (c) { if (isAll || (single && c !== a)) c.classList.remove('is-on'); });
          if (!isAll) a.classList.toggle('is-on', turnOn);
          var allChip = $('[data-qf-chip][data-all]', wrap);
          if (allChip) allChip.classList.toggle('is-on', !chips.some(function (c) { return c.classList.contains('is-on'); }));
        }
        shop.kzLoad(url);
      } else location.href = url;
    } catch (err) { }
  });

  /* In-stock by default: internal links to a collection get the availability filter (no extra redirect) */
  doc.addEventListener('click', function (e) {
    if (!root.hasAttribute('data-instock') || e.defaultPrevented) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.closest('[data-collection]')) return;
    try {
      if (sessionStorage.getItem('kzAllStock') === '1') return;
      var u = new URL(a.href, location.href);
      if (u.origin !== location.origin || !/\/collections\/[^\/]+\/?$/.test(u.pathname) || u.searchParams.has('filter.v.availability')) return;
      u.searchParams.set('filter.v.availability', '1');
      a.href = u.toString();
    } catch (err) { }
  }, true);

  doc.addEventListener('shopify:section:unload', function () { lockScroll(false); });

  window.KZ = { init: init };
})();
